import moment from 'moment';

export const parseUTCDate = (dateInput: string | Date): Date => {
  if (!dateInput) return null;

  // parse date for UTC
  return moment.utc(dateInput).toDate();
};

export const formatUTCDate = (
  date: Date | string,
  locale: string = 'en-GB',
  format: string = 'Do MMMM YYYY',
): string => {
  if (!date) return 'TBC';
  return moment.utc(date).locale(locale).format(format);
};

// start/end should be in correct order
export const ensureChronologicalOrder = (start: Date, end: Date): [Date, Date] => {
  return start > end ? [end, start] : [start, end];
};
